import ParamsParser from '@/plugins/params-parser.js';
import router from '../../plugins/vue-router';
import i18n from '../../plugins/i18n';
import axios from '../../plugins/axios';

const state = {
  user: {
    firstname: '',
    lastname: '',
    email: '',
    lang: '',
  },
  id: null,
  account: null,
  owner: null,
  table: {
    filterConfirm: i18n.t('words.filter', { extra: '' }),
    filterReset: i18n.t('words.reset', { extra: '' }),
    emptyText: i18n.t('words.empty', { extra: '' }),
  },
  datepicker: {
    start: new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
    start_calendar: new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
    end: new Date(new Date().setHours(23, 59, 59, 59)).getTime(),
    end_calendar: new Date(new Date().setHours(23, 59, 59, 59)).getTime(),
  },
  offset: new Date().getTimezoneOffset() / 60,
  accountObj: null,
  features: {},
  getFeature(featureName) {
    if (Object.keys(state.features).length < 1) return false;
    // eslint-disable-next-line no-shadow
    const feature = state.features.features.find(feature => feature.name === featureName);
    return feature && feature.limit;
  },
  segmentFilter: [],
};

const mutations = {
  firstname(state, value) {
    state.user.firstname = value;
  },
  lastname(state, value) {
    state.user.lastname = value;
  },
  email(state, value) {
    state.user.email = value;
  },
  lang(state, value) {
    state.user.lang = value;
  },
  id(state, value) {
    state.id = value;
  },
  account(state, value) {
    state.account = value;
  },
  owner(state, value) {
    state.owner = value;
  },
  start(state, value) {
    state.datepicker.start = (value)
      ? new Date(value).getTime()
      : new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  },
  end(state, value) {
    state.datepicker.end = (value)
      ? new Date(value).getTime()
      : new Date(new Date().setHours(23, 59, 59, 59)).getTime();
  },
  start_calendar(state, value) {
    state.datepicker.start_calendar = (value)
      ? new Date(value).getTime()
      : new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  },
  end_calendar(state, value) {
    state.datepicker.end_calendar = (value)
      ? new Date(value).getTime()
      : new Date(new Date().setHours(23, 59, 59, 59)).getTime();
  },
  accountObj(state, value) {
    state.accountObj = value;
  },
  features(state, value) {
    state.features = value;
  },
  segmentFilter(state, value) {
    state.segmentFilter = value;
  },
};

const actions = {
  toPage({}, name) {
    if (router.currentRoute.name !== name) return router.push({ name });
    location.reload();
  },
  async getUserData({ dispatch, commit }) {
    const response = await dispatch('users/find', `${state.id}?$populate[0]=account`, { root: true });
    const {
      firstname, lastname, email, lang, account,
    } = response;

    commit('firstname', firstname);
    commit('lastname', lastname);
    commit('email', email);
    commit('lang', lang);
    commit('accountObj', account);
    window.Frill('identify', { email: email, name: `${firstname} ${lastname}`, companies: [{ id: account._id, name: account.name }], attributes: { origin: 'dashboard' } });
  },
  async loadFeatures({ commit }) {
    const response = await axios.get('/account/plan');
    commit('features', response.data);
  },
  filterUser({ dispatch }, level) {
    dispatch('privileges/get', `?level=${level}`, { root: true });
  },
  parseFetchTable({}, objTable) {
    // Function for return parsed skip key
    const parsePage = (limit = 10, page = 0) => ({
      $skip: limit * ((page === 0) ? page : page - 1),
    });
    // Function for return parsed sort key
    const parseSort = (key = '_id', sort = 'ascend') => ({ [`$sort[${key}]`]: (sort === 'ascend') ? 1 : -1 });
    // Start ParamsParse
    const parser = new ParamsParser();
    const obj = { ...objTable };
    const sort = (typeof objTable.sortField !== 'undefined') ? parseSort(objTable.sortField, objTable.sortOrder) : {};
    const limit = parsePage(objTable.results, objTable.page);
    // Delete unnecessary keys
    delete obj.sortOrder;
    delete obj.sortField;
    delete obj.results;
    delete obj.page;
    // If is array
    Object.keys(obj).map(v => (v !== 'tags' && Array.isArray(obj[v]))
      && delete Object.assign(obj, {
        [(v.includes('[$in]')) ? v : `${v}[$in]`]: obj[v],
      })[v]);
    parser.byObj({ ...sort, ...limit, ...obj });
    return parser.parse();
  },
  FillForm({ rootGetters }, { values, getters }) {
    return new Promise((resolve) => {
      const obj = {};
      const data = (typeof getters === 'string') ? rootGetters[getters] : getters;
      Object.keys(values).map(key => obj[key] = typeof data[key] !== 'undefined' ? data[key] : '');
      resolve(obj);
    });
  },
};

const getters = {
  name: state => state.name,
  id: state => state.id,
  account: state => state.account,
  table_locale: state => state.table,
  start: state => state.datepicker.start,
  start_calendar: state => state.datepicker.start_calendar,
  end: state => state.datepicker.end,
  end_calendar: state => state.datepicker.end_calendar,
  firstname: state => state.user.firstname,
  lastname: state => state.user.lastname,
  email: state => state.user.email,
  lang: state => state.user.lang,
  user: state => state.user,
  owner: state => state.owner,
  offset: state => state.offset,
  accountObj: state => state.accountObj,
  features: state => state.features,
  getFeature: state => state.getFeature,
  segmentFilter: state => state.segmentFilter,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
